import { Component } from 'react';
import moment from 'moment';

const steps = {
  "hours": 3600200,
  "minutes": 60200,
  "seconds": 5200,
};

export default class extends Component {
  constructor (props) {
    super(props);

    this.state = { refresh: false };
  }

  componentDidMount () {
    this.reload();
  }

  componentWillUnmount () {
    clearTimeout(this.timer);
  }

  reload = () => {
    const { unit = "seconds" } = this.props;

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.reload();
      this.setState(state => ({ refresh: !state.refresh }));  // force rendering
    }, steps[unit] || 30200);
  };

  render () {
    const { value, unit = "seconds" } = this.props;
    return moment().diff(value, unit);
  }
}


// WEBPACK FOOTER //
// ./src/components/Timer.js